import styled from '../../theme';
const BASE_WIDGET_PADDING_MOBILE = 10;
const DWEB_MAX_WIDTH = 1200;
export const Wrapper = styled.article `
  width: 100%;
  padding: 0 ${BASE_WIDGET_PADDING_MOBILE}px;
  background: #ffffff;

  & a[href] {
    color:  ${(props) => props.theme.brandPrimary};
    text-decoration: underline;
    margin: 0 3px;
  }
`;
export const Title = styled.div `
  font-family: inherit;
  width: 100%;
  max-width: ${DWEB_MAX_WIDTH}px;
  font-size: 24px;
  line-height: 28px;
  font-weight: 500;
  text-transform: capitalize;
  padding: 0;
  margin-top: 56px;
  padding-right: 15px;
  text-align: ${(props) => props.alignment};

  @media (max-width: ${(props) => props.theme.breakpoints.xl}px) {
    margin-top: ${30 - BASE_WIDGET_PADDING_MOBILE / 2}px;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
    padding: 5px 0px 0px;
  }
`;
export const DynamicHtmlWrapper = styled.div `
  width: 100%;
  height: 100%;
  position relative;
  background: #ffffff;
`;
export const DynamicHtmlContainer = styled.div `
  width: 100%;
  height: 100%;
`;
